import atr from "./atr";
import { Supertrend as defaultOptions } from "./defaultOptionsForComputation";

const isValidNumber = (value) =>
  typeof value === "number" && Number.isFinite(value);

export default function () {
  let options = defaultOptions;

  function calculator(data = []) {
    if (!Array.isArray(data) || data.length === 0) return [];

    const { period, multiplier } = options;
    const atrCalculator = atr().options({
      windowSize: Math.max(1, period || 1),
    });
    const atrValues = atrCalculator(data);

    const results = new Array(data.length).fill(undefined);

    for (let i = 0; i < data.length; i += 1) {
      const datum = data[i] || {};
      const high = datum.high;
      const low = datum.low;
      const close = datum.close;
      const atrValue = atrValues[i];

      if (
        !isValidNumber(high) ||
        !isValidNumber(low) ||
        !isValidNumber(close) ||
        !isValidNumber(atrValue)
      ) {
        continue;
      }

      const median = (high + low) / 2;
      const factoredATR = (multiplier || 0) * atrValue;
      let uptrend = median - factoredATR;
      let downtrend = median + factoredATR;

      if (i > 0) {
        const prev = data[i - 1];
        const prevResult = results[i - 1];
        if (prev && prevResult) {
          if (prev.close > prevResult.uptrend && prevResult.uptrend > uptrend) {
            uptrend = prevResult.uptrend;
          }
          if (
            prev.close < prevResult.downtrend &&
            prevResult.downtrend < downtrend
          ) {
            downtrend = prevResult.downtrend;
          }
        }
      }

      let direction = 1;
      if (i > 0) {
        const prevResult = results[i - 1];
        if (prevResult) {
          direction = prevResult.direction;
          if (close > prevResult.downtrend) direction = 1;
          else if (close < prevResult.uptrend) direction = -1;
        }
      }

      results[i] = {
        uptrend,
        downtrend,
        direction,
        value: direction > 0 ? uptrend : downtrend,
      };
    }

    return results;
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    return Math.max(1, period || 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
